<div *ngIf="showkeywords && objectKeywords" class="row pt-4"
    style="margin-left: 1px;">
    <div style="text-align: center;" class="col 12 keywords-top-heading-section">
        <a class="keywords-top-heading-section-content" title="{{letter}}"
            *ngFor="let letter of objectKeywords" (click)="focusToAlphabets(letter)"
            (keyup.enter)="focusToAlphabets(letter)"
            (keyup.space)="focusToAlphabets(letter)" tabindex="0">{{letter}}</a>
    </div>
    <form [formGroup]="keywordSearchForm">
        <div class="input-group mb-3">
            <input type="text" class="form-control keyword-search-input"
                placeholder="Search keyword" formControlName="keySearchValue"
                (keyup)="focustoKeyword()">
            <div class="input-group-append">
                <span class="input-group-text keyword-input-group">
                    <fa-icon aria-hidden="true" aria-hidden="true"
                        [icon]="['fas', 'magnifying-glass']" (click)="focustoKeyword()"
                        (keyup.enter)="focustoKeyword()"
                        (keyup.space)="focustoKeyword()" tabindex="0">
                    </fa-icon>
                </span>
            </div>
        </div>
    </form>
    <div class="scrollable-div" #keywords>
        <div *ngFor="let letter of objectKeywords">
            <div #alphHeading class="col-12 no-padding keyword-alphabet-heading">
                {{letter}}</div>
            <span #keywordSpan class="bordered-text"
                *ngFor="let words of this.keywordsByFirstLetter[letter]"
                (click)="clickOnEachKeywords(words)"
                (keyup.enter)="clickOnEachKeywords(words)"
                (keyup.space)="clickOnEachKeywords(words)" tabindex="0"
                id="{{words}}">{{words}}</span>
        </div>
    </div>
</div>
<div style="text-align:center ;font-weight:bold;"
    *ngIf="showkeywords && objectKeywords.length === 0">No
    keywords found</div>
<div *ngIf="search_keywords.length > 0" class="row pt-2"
    style="margin-top:5px ;margin-left: 1px;">
    <div class="col 12 keywords-top-heading-section">
        <span class="black-label"
            style="font-size: 25px;margin-top: 2%;">{{'article_listing.keyword_filter' |
            translate}}</span>
    </div>
    <div>
        <span *ngFor="let keywrds of search_keywords"
            class="selected_keywords">{{keywrds}}
            <fa-icon style="color: white;" aria-hidden="true" [icon]="['fas', 'xmark']"
                class="p-2 pb-0 size " (click)="clickOnEachKeywords(keywrds)"
                (keyup.enter)="clickOnEachKeywords(keywrds)"
                (keyup.space)="clickOnEachKeywords(keywrds)" tabindex="0"></fa-icon>
        </span>
    </div>
</div>